export default __webpack_public_path__ + "static/media/editRule.26c5fd9d.svg";